var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.tab, expression: "tab" }
      ],
      staticClass: "big no-padding-confirm",
      attrs: {
        title: _vm.$t("tradeCenter.operatorTxPair.title"),
        closeIcon: true,
        close: _vm.close
      }
    },
    [
      _c("div", { staticClass: "head" }, [_c("tx-pair-info")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "tab" }, [
        _c(
          "div",
          {
            staticClass: "tab__item",
            class: { active: _vm.tab === "token" },
            on: {
              click: function($event) {
                return _vm.switchTab("token")
              }
            }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeCenter.operatorTxPair.tokenTab")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tab__item",
            class: { active: _vm.tab === "operator" },
            on: {
              click: function($event) {
                return _vm.switchTab("operator")
              }
            }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeCenter.operatorTxPair.operatorTab")) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tab === "token",
              expression: "tab === 'token'"
            }
          ],
          staticClass: "tab-content"
        },
        [
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("tokenCard.tokenInfo.labels.tokenName")) + ":"
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "click-able", on: { click: _vm.goToTokenDetail } },
              [
                _vm._v(
                  _vm._s(_vm.tokenDetail.name) +
                    " (" +
                    _vm._s(_vm.tokenDetail.symbol) +
                    ")"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.tokenId")) + ":")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "click-able", on: { click: _vm.goToTokenDetail } },
              [_vm._v(_vm._s(_vm.tokenDetail.tokenId))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("tokenCard.tokenInfo.labels.overview")) + ":"
              )
            ]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.getOverview(_vm.tokenDetail.overview)) +
                "\n            "
            ),
            _vm.tokenDetail.overview &&
            _vm.tokenDetail.overviewLink &&
            _vm.tokenDetail.overviewLink.length
              ? _c(
                  "span",
                  {
                    staticClass: "click-able view-more",
                    on: {
                      click: function($event) {
                        return _vm.openUrl(_vm.tokenDetail.overviewLink[0])
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tokenCard.tokenInfo.labels.viewmore"))
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.total")) + ":")
            ]),
            _vm._v(
              " " +
                _vm._s(_vm.tokenDetail.showTotalSupply || "--") +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.type")) + ":")
            ]),
            _vm._v(" " + _vm._s(_vm.tokenDetail.ttype) + "\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.gate")) + ":")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "click-able",
                on: {
                  click: function($event) {
                    return _vm.openUrl(
                      _vm.tokenDetail.gateway
                        ? _vm.tokenDetail.gateway.website
                        : null
                    )
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.tokenDetail.gateway
                      ? _vm.tokenDetail.gateway.name || "--"
                      : "--"
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.website")) + ":")
            ]),
            _vm._v(" "),
            !_vm.tokenDetail.websiteLink || !_vm.tokenDetail.websiteLink.length
              ? _c("div", [_vm._v("--")])
              : _c(
                  "div",
                  _vm._l(_vm.tokenDetail.websiteLink, function(link, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        staticClass: "click-able",
                        on: {
                          click: function($event) {
                            return _vm.openUrl(link)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(link || "--") +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  0
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("tokenCard.tokenInfo.labels.whitePaper")) + ":"
              )
            ]),
            _vm._v(" "),
            !_vm.tokenDetail.whitepaperLink ||
            !_vm.tokenDetail.whitepaperLink.length
              ? _c("div", [_vm._v("--")])
              : _c(
                  "div",
                  _vm._l(_vm.tokenDetail.whitepaperLink, function(link, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        staticClass: "click-able",
                        on: {
                          click: function($event) {
                            return _vm.openUrl(link)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(link || "--") +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  0
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(
                _vm._s(_vm.$t("tokenCard.tokenInfo.labels.explorer")) + ":"
              )
            ]),
            _vm._v(" "),
            !_vm.tokenDetail.explorerLink ||
            !_vm.tokenDetail.explorerLink.length
              ? _c("div", [_vm._v("--")])
              : _c(
                  "div",
                  _vm._l(_vm.tokenDetail.explorerLink, function(link, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        staticClass: "click-able",
                        on: {
                          click: function($event) {
                            return _vm.openUrl(link)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(link || "--") +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  0
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.github")) + ":")
            ]),
            _vm._v(" "),
            !_vm.tokenDetail.githubLink || !_vm.tokenDetail.githubLink.length
              ? _c("div", [_vm._v("--")])
              : _c(
                  "div",
                  _vm._l(_vm.tokenDetail.githubLink, function(link, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        staticClass: "click-able",
                        on: {
                          click: function($event) {
                            return _vm.openUrl(link)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(link || "--") +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  0
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.media")) + ":")
            ]),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tokenDetail.facebookLink,
                  expression: "tokenDetail.facebookLink"
                }
              ],
              staticClass: "media-icon",
              attrs: { src: require("assets/imgs/facebook.svg") },
              on: {
                click: function($event) {
                  return _vm.openUrl(_vm.tokenDetail.facebookLink[0])
                }
              }
            }),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tokenDetail.twitterLink,
                  expression: "tokenDetail.twitterLink"
                }
              ],
              staticClass: "media-icon",
              attrs: { src: require("assets/imgs/twitter.svg") },
              on: {
                click: function($event) {
                  return _vm.openUrl(_vm.tokenDetail.twitterLink[0])
                }
              }
            }),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tokenDetail.telegramLink,
                  expression: "tokenDetail.telegramLink"
                }
              ],
              staticClass: "media-icon",
              attrs: { src: require("assets/imgs/telegram.svg") },
              on: {
                click: function($event) {
                  return _vm.openUrl(_vm.tokenDetail.telegramLink[0])
                }
              }
            }),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tokenDetail.mediumLink,
                  expression: "tokenDetail.mediumLink"
                }
              ],
              staticClass: "media-icon",
              attrs: { src: require("assets/imgs/medium.svg") },
              on: {
                click: function($event) {
                  return _vm.openUrl(_vm.tokenDetail.mediumLink[0])
                }
              }
            }),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tokenDetail.discordLink,
                  expression: "tokenDetail.discordLink"
                }
              ],
              staticClass: "media-icon",
              attrs: { src: require("assets/imgs/discord.svg") },
              on: {
                click: function($event) {
                  return _vm.openUrl(_vm.tokenDetail.discordLink[0])
                }
              }
            }),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tokenDetail.redditLink,
                  expression: "tokenDetail.redditLink"
                }
              ],
              staticClass: "media-icon",
              attrs: { src: require("assets/imgs/reddit.svg") },
              on: {
                click: function($event) {
                  return _vm.openUrl(_vm.tokenDetail.redditLink[0])
                }
              }
            }),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tokenDetail.youtubeLink,
                  expression: "tokenDetail.youtubeLink"
                }
              ],
              staticClass: "media-icon",
              attrs: { src: require("assets/imgs/youtube.svg") },
              on: {
                click: function($event) {
                  return _vm.openUrl(_vm.tokenDetail.youtubeLink[0])
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tab === "operator",
              expression: "tab === 'operator'"
            }
          ],
          staticClass: "tab-content"
        },
        [
          _c("div", { staticClass: "content__item" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tradeCenter.operator.name")) + ":")
            ]),
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.operatorInfo
                    ? _vm.operatorInfo.name
                    : _vm.$t("tradeCenter.operator.noName")
                ) +
                "\n            "
            ),
            _c("img", {
              staticClass: "operator-img",
              attrs: { src: _vm.operatorIcon }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tradeCenter.operator.address")) + ":")
            ]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.operatorInfo ? _vm.operatorInfo.address : "--") +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tradeCenter.operator.overview")) + ":")
            ]),
            _vm._v(
              "\n            " + _vm._s(_vm.operatorOverview) + "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content__item _b" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("tradeCenter.operator.txPair")) + ":")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tx-pair-list" },
              [
                _vm._l(_vm.operatorTradePairs, function(pairs, category) {
                  return _vm._l(pairs, function(symbol) {
                    return _c(
                      "span",
                      {
                        key: symbol,
                        staticClass: "symbol",
                        on: {
                          click: function($event) {
                            return _vm.switchTxPair({
                              category: category,
                              symbol: symbol
                            })
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(symbol.replace("_", "/")) +
                            "\n                    "
                        )
                      ]
                    )
                  })
                })
              ],
              2
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }